import Query from 'components/Query';

const UserQuery = ({children, ...options}) => (
    <Query queryKey="user" {...options}>
        {children}
    </Query>
);

export default UserQuery;
